import { cn } from '@/utils/classNames.ts';

export type ControlTone = 'light' | 'dark';

export const pillClassName =
  'inline-flex min-h-11 items-center rounded-full border border-primary/60 px-4 text-sm font-medium text-[#2F2D2A] transition-[transform,background-color] duration-[160ms] ease-[cubic-bezier(.22,1,.36,1)] active:scale-[0.97] motion-reduce:active:scale-100 disabled:cursor-not-allowed disabled:opacity-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary [@media(hover:hover)_and_(pointer:fine)]:hover:bg-primary/10';

export const externalLinkClassName = (tone: ControlTone): string =>
  cn(
    'inline-flex min-h-11 items-center gap-1.5 text-sm font-medium underline underline-offset-4 transition-[text-decoration-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
    tone === 'dark'
      ? 'text-primary decoration-primary/40 [@media(hover:hover)]:hover:decoration-primary'
      : 'text-[#2F2D2A] decoration-gold-deep/50 [@media(hover:hover)]:hover:decoration-gold-deep'
  );

export const externalLinkIconClassName = (tone: ControlTone): string =>
  cn('h-4 w-4 shrink-0', tone === 'dark' ? 'text-primary' : 'text-gold-deep');
